module.exports = __webpack_public_path__ + "img/MAGIC-584x584.5036fefb.webp";